module.exports = __webpack_public_path__ + "static/img/1-1.0082f17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/1-1.jpg
// module id = EGuS
// module chunks = 0